import { html, nothing } from 'lit';

export function renderBlockingLoader(isLoading = true) {
    return isLoading ? html`<blocking-loader></blocking-loader>` : nothing;
}
